import styled from "styled-components";

export const TitleData = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  font-weight: bolder;
  padding: 20px 0 10px 0;
`;

export const CardData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ButtonSection = styled.div`
  height: -webkit-fill-available;
  position: relative;
  bottom: 0;
  width: 100%;
`;

export const OtherCard = styled.p`
  width: 100%;
  display: flex;
  gap: 2.5px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;



export const Image = styled.p`
  width: 45px;
  height: 27px;
`;

export const SelectOtherCard = styled.div``;

export const NewCard = styled.span`
  color: #ff5c5c !important;
  cursor: pointer;
`;
